// extracted by mini-css-extract-plugin
export default {"wrapper":"go-z","response":"ho-z","error":"io-z","disabled":"jo-z","buttons":"ko-z","feedbackQuestionSection":"lo-z","yesNoWrapper":"mo-z"};